export default {
    getConstans() {
        return {
            IMAGE:{
                ICON_CHANGE: window.origin + '/assets/images/autorenew_u5675.png',
            },
            FORMAT_DATERANGE_FILTER: 'dd/mm/yy',
            LIST_APPLY_MAINTENANCE: [{value:0,name:"Không bảo trì định kỳ"},{value:1,name:"Có bảo trì định kỳ"}],
            LIST_TYPE_MAINTENANCE: [{value:0,name:"Bảo trì tận nơi"},{value:1,name:"Bảo trì tại TTBH"}],
            MAINTENANCE: {
                PROCESS_STATUS:{
                    PLAN:0,//Kế hoạch
                    MAINTENANCE_NEEDED:1,//Cần bảo trì
                    PROCESSING:2,//Đang thực hiện
                    FOR_MAINTENANCE:3,//Đã bảo trì
                    OUT_OF_DATE:4,//Quá hạn
                    CANCEL_PLAN_ONLY:5,//Hủy kế hoạch
                }
            },
            WARRANTY_REPAIR: {
                TYPE_SERVICE:{
                    MAINTENANCE:'T07',//Bảo trì định kỳ
                    REPAIR_APPRAISAL:'T08',//Sửa chữa SP thẩm định
                    WARRANTY:'T01',//Bảo hành sản phẩm
                    REPAIR:'T02',//Sửa chữa tính phí
                    APPRAISAL:'T03',//Khảo sát - thẩm định
                    OPERATION:'T04',//Lắp đặt - vận
                    ACCEPTANCE:'T05',//Nghiệm thu
                    TRAINING:'T06',//Tư vấn - đào tạo
                },
                PROCESS_STATUS:{
                    SEND_REQUIRE:0,//Gửi yêu cầu
                    WAITING_RECEIVED:1,//Chờ tiếp nhận
                    WAITING_IMPLEMENTATION:2,//Chờ thực hiện
                    WAITING_DELIVERY:3,//Chờ giao trả
                    COMPLETE:4,//Hoàn thanh
                },
                PRODUCT_STATUS:{
                    WAITING_IMPLEMENTATION:0,//Chờ thực hiện
                    MADE:1,//Đã thực hiện
                    SEND_REQUIRE:5,//Gửi yêu cầu
                    AGREE_RECEIVE:6,//Đồng ý tiếp nhận
                    DISCLAIMER:7,//Từ chối tiếp nhận
                    SUPPORT_DONE:8,//Đã hỗ trợ xong
                }
            },
            REQUEST_RETURN: {
                PROCESS_STATUS:{
                    ARE_ASKING:0,//Đang yêu cầu
                    WAITING_APPRAISAL:1,//Chờ thẩm định
                    CANCEL_REQUEST:2,//Hủy yêu cầu
                    AUTO_APPROVED:3,//Tự động duyệt
                    DISAGREE:4,//ko duyệt
                    APPROVED:5,//Đã duyệt
                    WAIT_REQUEST:6,//Chờ gửi yêu cầu
                },
                RETURN_TYPE:{
                    CHANGE:0,//Đổi
                    RETURN:1,//Trả
                }
            },
            SETTING:{
                MAXIMUM_WARRANTY_EXTENSION_TIME:'MAXIMUM_WARRANTY_EXTENSION_TIME'
            },
            COVERT_UNIT_MOMMENT:{
                'month':'M',
                'day':'days',
            },
            LIST_OPTION_COMMON:{
                TEXT_TOTAL_ITEM:'Tổng số dòng:',
                PER_PAGE_OPTIONS: [10, 20, 50],
                //PAGINATOR_TEMPLATE: 'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
                PAGINATOR_TEMPLATE: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
                PAGINATION_ROWS_DEFAULT:20,
            },
            USER:{
                USER_TYPE:{
                    CUSTOMER:1,//Khách hàng
                    STAFF:2,//Nhân viên
                },
            },
            TEXT_NOT_FIND_DATA_SELECT:"Không tìm thấy dữ liệu"
        };
    }
}